import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input, FormGroup } from 'reactstrap';
import Select from 'react-select';
import _ from 'lodash';
import { IQueue, SelectOption } from '../../../globals/interfaces';

const importOptions = [
    'Already Picked up',
    'Driver Issue',
    'Export Shipment',
    'Freight has not arrived yet',
    'No customs clearance',
    'Unpaid Fees',
    'On Customs Hold / USDA Hold',
    'Shipment is not ready',
    'Unable to locate'
];

const exportOptions = [
    'Booking Issue',
    'DG Issue',
    'Documents',
    'Driver Issue',
    'Early Tender',
    'Late / Missed lockout',
    'Packaging',
    'Safety/Security',
    'Damaged Freight / ULD'
]

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    rejectReason: SelectOption;
    setRejectReason: (option: SelectOption) => void;
    s_notes: string;
    set_s_notes: (s_notes: string) => void;
    reject: () => Promise<void>
    rejectAwb: IQueue;
}

export default function ModalReject ({
    modal,
    setModal,
    rejectReason,
    setRejectReason,
    s_notes,
    set_s_notes,
    reject,
    rejectAwb
}: Props) {

    const rejectSelectOptions: Array<SelectOption> = [{
        label: '',
        value: ''
    }];
    const useOptions = rejectAwb.s_type === 'EXPORT' ? exportOptions : importOptions;
    useOptions.sort((a, b) => a.localeCompare(b)).map(option => rejectSelectOptions.push({ 
        label: option,
        value: option 
    }));

    const toggle = () => setModal(!modal);

    return (
        <div>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader>Reject</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label>Select Reject Reason:</Label>
                        <Select 
                            value={rejectReason}
                            options={rejectSelectOptions}
                            onChange={(selectedOption: SelectOption) => setRejectReason(selectedOption)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>Notes:</Label>
                        <Input type={'textarea'} value={s_notes} onChange={(e: any) => set_s_notes(e.target.value)} />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button 
                        color="danger" 
                        onClick={() => reject()}
                        disabled={!String(rejectReason.value).length || s_notes.length < 5}
                    >
                        Reject
                    </Button>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}